/**
 * Palette used to colour job-pipeline stage bars/borders. Cycled by index
 * (`index % borderColors.length`) so any number of stages gets a stable colour.
 *
 * Relocated from `pages/ats-job-details/tabs/JobPipeline/helper` so the Redux
 * pipeline slice can consume it without a store → pages boundary violation.
 */
export const borderColors = ['#B961FF', '#61C6FF', '#FFA361', '#3CCDC4'];

/**
 * Sort the Application Review column falls back to when the user has no stored
 * per-stage preference. Shared so the pipeline slice and the column agree on
 * what "custom sort" means — when they drift, the slice keeps a stale list the
 * column never refetches.
 *
 * The user-facing label is flag-dependent, so callers spread this and add it.
 */
export const APP_REVIEW_DEFAULT_SORT = {
  value: 'desc',
  element: 'ai_review_score',
  order: 'desc',
};

// URL handoff from the pipeline's "No AI score" link to the Candidates tab,
// which applies the failed-AI-review filter in place of the saved filters.
export const AI_REVIEW_STATUS_QUERY_PARAM = 'aiReviewStatus';
export const AI_REVIEW_STATUS_FAILED = 'failed';
